import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import ProfileView from "../components/ProfileView";

export default function PublicProfile() {
  const { slug } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get(`/players/${slug}`);
        setProfile(data.profile);
      } catch {
        setNotFound(true);
      }
      setLoading(false);
    };
    load();
  }, [slug]);

  // SEO meta tags
  useEffect(() => {
    if (!profile) return;
    const gen = profile.generated_profile || {};
    const identity = profile.onboarding_data?.identity || {};
    const title = `${profile.name} - ${identity.primary_position || "Player"} | Elite Scouting Network`;
    const description = gen.headline || gen.overview || `Professional football profile for ${profile.name}`;
    document.title = title;
    const setMeta = (property, content) => {
      let el = document.querySelector(`meta[property="${property}"]`) || document.querySelector(`meta[name="${property}"]`);
      if (!el) {
        el = document.createElement("meta");
        if (property.startsWith("og:")) el.setAttribute("property", property);
        else el.setAttribute("name", property);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("og:title", title);
    setMeta("og:description", description);
    setMeta("og:type", "profile");
    setMeta("description", description);
    setMeta("og:url", window.location.href);
    return () => { document.title = "Elite Scouting Network"; };
  }, [profile]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (notFound) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-black text-[#F5F5F5] mb-4">PROFILE NOT FOUND</h1>
          <p className="text-[#A3A3A3]">This profile may not be published or doesn't exist.</p>
        </div>
      </div>
    );
  }

  return <ProfileView profile={profile} isPreview={false} />;
}
